import { getIsFunction } from '../customTypeGuards';

/* eslint-disable @typescript-eslint/ban-types */
export function assertIsFunction(value: unknown): asserts value is Function {
  /* eslint-enable @typescript-eslint/ban-types */
  if (!getIsFunction(value)) {
    throw new Error('Value passed to assertIsFunction is not a function.');
  }
}
